import { Box, Chip } from "@mui/material";
import Paper from "@mui/material/Paper";
import {
  type GridColDef,
  type GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React from "react";
import { getDiffDaysMessage } from "../../utils/main";
import BaseTable from "../datagrid/BaseTable.tsx";

export default function CodeListDataGrid({
  codes,
  isCodeOffsetEnabled,
  tableId = "code-list",
}: {
  codes: Code[];
  isCodeOffsetEnabled: boolean;
  tableId?: string;
}) {
  const columns: GridColDef<Code>[] = [
    {
      field: "code",
      headerName: "Code",
      flex: 0.7,
      minWidth: 50,
      renderCell: (params: GridRenderCellParams<Code>) => {
        return <Chip label={params.row.code} size="small" variant="outlined" />;
      },
      type: "string",
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 150,
      type: "string",
    },
  ];

  if (isCodeOffsetEnabled) {
    columns.push({
      field: "diffDays",
      headerName: "Code Date",
      flex: 1,
      minWidth: 100,
      renderCell: (params: GridRenderCellParams) => {
        return <>{getDiffDaysMessage(params.row.diffDays)}</>;
      },
      type: "number",
    });
  }

  // this maps the ID value on the code rows so that the datagrid has a proper unique key per row
  const rows = codes.map((code: Code) => {
    if (!code.id) code.id = `${code.code}+${crypto.randomUUID()}`;
    return code;
  });

  return (
    <Paper className={"code-list-table-background"}>
      <Box className={"datagrid-box"}>
        <BaseTable<Code>
          loading={false}
          tableId={`${tableId}-table`}
          sx={{
            overflowX: "auto",
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          disableDensitySelector
          highlightField={"createdAt"}
          pageSizeOptions={[10, 20, { value: -1, label: "All" }]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          columns={columns}
          rows={rows || []}
        />
      </Box>
    </Paper>
  );
}
